import styled from 'styled-components'

export const EmptyStateStyles = styled.div`
  text-align: center;
  margin-top: 1vh;
  .wrapper {
    width: 314px;
    margin: 0 auto;
  }
  > svg {
    margin-bottom: 60px;
  }
  p {
    text-align: center;
    margin-bottom: 24px;
  }
`
